import importApis from "../../api/import";

const state = {
  listFile: {
    data: [
      {
        id: 1,
        fileName: 'filename1',
        status: 'created',
        importTime: '01/03/2021'
      }
    ]
  },
  packages: {}
};

const getters = {};

const mutations = {
  SET_LIST_FILE: (state, payload) => state.listFile = payload,
  SET_IMPORT_DETAIL: (state, payload) => state.packages = payload,
};

const actions = {
  async getListFile({commit}, data) {
    // await importApis.createPackage(data);
    // await commit("SET_LIST_FILE", data);
  },
  async getdetail({commit}, payload) {
    const {data} = await importApis.getdetail(payload);
    await commit("SET_IMPORT_DETAIL", data);
},
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};